import React from "react";

const Footer = () => {
    return (
        <footer>
            <div className="footer-logo">
            </div>

                <ul className="footer-social">
                    <li>
                        <a href="https://www.facebook.com/">
                            <i className="fa fa-facebook-square" aria-hidden="true"></i>
                            <span>Facebook</span>
                        </a>
                    </li>
                    <li className = "separator">
                        |
                    </li>

                    <li>
                        <a href="https://twitter.com/">
                            <i className="fa fa-twitter" aria-hidden="true"></i>
                            <span>Twitter</span>
                        </a>
                    </li>
                    <li className = "separator">
                        |
                    </li>
                    <li>
                        <a href="https://twitter.com/">
                            <i className="fa fa-instagram" aria-hidden="true"></i>
                            <span>Instagram</span>
                        </a>
                    </li>
                    <li className = "separator">
                        |
                    </li>
                    <li>
                        <a href="https://twitter.com/">
                            <i className="fa fa-pinterest" aria-hidden="true"></i>
                            <span>Pinterest</span>
                        </a>
                    </li>
                </ul>
            <div className ="copyright-text">
                <span>© Copyright Roadsign 2022</span>
            </div>
        </footer>
    );
};

export default Footer;
